var exports = {
  "Ef": "UserAreaPopout.module__customStatusRow___bEtGdn",
  "fF": "UserAreaPopout.module__customStatusPlaceholder___bEtGdn",
  "yB": "UserAreaPopout.module__customStatusPlaceholderText___bEtGdn",
  "mo": "UserAreaPopout.module__customStatusPlaceholderIcon___bEtGdn",
  "Ar": "UserAreaPopout.module__copyUsernameButton___bEtGdn",
  "kL": "UserAreaPopout.module__container___bEtGdn",
  "qr": "UserAreaPopout.module__footer___bEtGdn",
  "mH": "UserAreaPopout.module__actionGroup___bEtGdn",
  "Gv": "UserAreaPopout.module__editProfileButton___bEtGdn",
  "hP": "UserAreaPopout.module__actionButton___bEtGdn",
  "k3": "UserAreaPopout.module__actionDivider___bEtGdn",
  "d3": "UserAreaPopout.module__actionButtonDisabled___bEtGdn",
  "gE": "UserAreaPopout.module__actionIcon___bEtGdn",
  "Iz": "UserAreaPopout.module__actionContent___bEtGdn",
  "ZJ": "UserAreaPopout.module__actionLabel___bEtGdn",
  "aN": "UserAreaPopout.module__actionHint___bEtGdn",
  "oS": "UserAreaPopout.module__actionChevron___bEtGdn",
  "qW": "UserAreaPopout.module__statusMenu___bEtGdn" + " " + __webpack_require__(384626)["HG"],
  "C6": "UserAreaPopout.module__expiryPopup___bEtGdn" + " " + __webpack_require__(384626)["HG"],
  "MH": "UserAreaPopout.module__statusMenuRow___bEtGdn",
  "v0": "UserAreaPopout.module__statusMenuItem___bEtGdn" + " " + __webpack_require__(384626)["AS"],
  "Tb": "UserAreaPopout.module__statusMenuIcon___bEtGdn",
  "Te": "UserAreaPopout.module__statusMenuText___bEtGdn",
  "Ye": "UserAreaPopout.module__statusMenuLabel___bEtGdn",
  "wK": "UserAreaPopout.module__statusMenuDescription___bEtGdn" + " " + __webpack_require__(384626)["Lo"],
  "Tc": "UserAreaPopout.module__statusMenuChevron___bEtGdn",
  "L7": "UserAreaPopout.module__expiryItem___bEtGdn" + " " + __webpack_require__(384626)["AS"],
  "ue": "UserAreaPopout.module__expiryLabel___bEtGdn",
};

module.exports = exports;
